import { withTranslation } from "react-i18next";
import { useContext, useEffect, useMemo, useState } from "react";
import NewFormCard from "./NewFormCard";
import {
  AdjustmentsHorizontalIcon,
  MagnifyingGlassIcon,
  SparklesIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { getFilteredData } from "../../../utils/functions/filteredForms";
import {
  CompletionsContext,
  ContactIdContext,
  LoadingContext,
  TypesContext,
} from "../../../App";
import {
  MsalInstanceContext,
  VariablesContext,
} from "../../../auth/AppProvider";
import { FormTitleContext } from "../../../layout/Vertical/Global";
import { initCompletion } from "../../../utils/requests/completions";
import { useNavigate, useSearchParams } from "react-router-dom";
import AIAssistantModal from "./AIAssistantModal";
import FiltersModal from "./FiltersModal";

function getAcademicYear() {
  const now = new Date();
  const y = now.getFullYear();
  return now.getMonth() >= 6 ? `${y} · ${y + 1}` : `${y - 1} · ${y}`;
}

function NewApplication({ t }) {
  const [isVisible, setIsVisible] = useState(false);
  const [filtersCompletion, setFiltersCompletion] = useState([]);
  const [noAvailableForms, setNoAvailableForms] = useState(false);
  const [search, setSearch] = useState("");
  const [showAIModal, setShowAIModal] = useState(false);
  const [showFiltersModal, setShowFiltersModal] = useState(false);

  const [allCompletions, setAllCompletions] = useContext(CompletionsContext);
  const msalInstance = useContext(MsalInstanceContext);
  const variables = useContext(VariablesContext);
  const [loading, setLoading] = useContext(LoadingContext);
  const contactId = useContext(ContactIdContext);
  const [allcompletions] = useContext(CompletionsContext);
  const [, setFormTitle] = useContext(FormTitleContext);
  // init state
  const [typesParameters] = useContext(TypesContext);
  const [completions, setCompletions] = useState([]);
  const [type, setType] = useState(null);
  let [searchParams] = useSearchParams();
  const [filters, setFilters] = useState([]);
  const [cardFilters, setCardFilters] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    setFormTitle(null);
  }, [variables, msalInstance]);

  useEffect(() => {
    const selectedType = typesParameters.find((t) => t.selected === true);
    setType(selectedType);
    if (!typesParameters) {
      setLoading(false);
    }
    if (selectedType && !selectedType.canCreateNewCompletion) {
      navigate("/");
    }
  }, [typesParameters]);

  // Get the first eligible filter to be used as a tab
  const tabFilter = useMemo(() => {
    const eligible = filters.filter(
      (f) => f.id !== "name" && f.id !== "description" && f.options?.length > 1,
    );
    if (!eligible.length) return null;
    return eligible[0];
  }, [filters]);

  useEffect(() => {
    let data = getFilteredData(filters, completions);

    if (search.trim()) {
      const q = search.trim().toLowerCase();
      data = data.filter((c) => c.label?.toLowerCase().includes(q));
    }

    try {
      data = data.sort((a, b) => {
        const av =
          a.parameters?.find((p) => p.name === "niveau_etude_souhaite")
            ?.value ?? "";
        const bv =
          b.parameters?.find((p) => p.name === "niveau_etude_souhaite")
            ?.value ?? "";
        return av < bv ? -1 : 1;
      });
    } catch (e) { }

    setFiltersCompletion(data);
  }, [filters, completions, search]);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 250);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (allcompletions && allcompletions.length) {
      if (type) {
        var Ncompletions = allcompletions.filter(
          (c) => c.typeId === type.id && !c.objectAssociated,
        );
        if (Ncompletions && Ncompletions.length > 0) {
          setCompletions(Ncompletions);
          setLoading(false);
          var filtersConstruction = type.filters.map((f) => {
            return { ...f };
          });
          filtersConstruction = filtersConstruction
            .map((f) => {
              var valueprefiltered = false;
              if (searchParams.get(f.id)) {
                valueprefiltered = searchParams.get(f.id).split(",");
              }
              f.options = Ncompletions.map((c) =>
                c.properties.hasOwnProperty(f.name)
                  ? { value: c.properties[f.name], label: c.properties[f.name] }
                  : null,
              )
                .filter(
                  (c, index, self) =>
                    c !== null &&
                    self.findIndex((sc) => sc.value === c.value) === index,
                )
                .filter(
                  (c) =>
                    c.value !== "" && c.value !== null && c.value !== undefined,
                )
                .map((c) => {
                  return {
                    value: c.value,
                    label: c.label,
                    actif: valueprefiltered
                      ? valueprefiltered.find((v) => v === c.value)
                      : false,
                  };
                });
              f.options.sort((a, b) => a.label.localeCompare(b.label));
              if (f.options == null || f.options.length <= 0) {
                return null;
              }
              return f;
            })
            .filter((f) => f !== null);
          if (filtersConstruction && filtersConstruction.length > 0) {
            setFilters(filtersConstruction.filter((f) => f.options && f.options.length > 1));
            setCardFilters(filtersConstruction.filter((f) => f.id !== "name" && f.id !== "description"));
          }
        } else {
          setNoAvailableForms(true);
        }
      }
    }
  }, [allcompletions, msalInstance, type]);

  function onDataChange(filtersLoc) {
    var fullFilteredData = getFilteredData(filtersLoc, completions);
    var filteredData = completions;
    var filteredOptions = [];
    filtersLoc.forEach((filterLoc) => {
      var options = filterLoc.options.map((opt) => {
        var am = fullFilteredData.filter(
          (fD) => fD.properties?.[filterLoc.name] === opt.value,
        ).length;
        return { ...opt, amount: am };
      });
      filteredOptions.push({
        id: filterLoc.id,
        name: filterLoc.name,
        options,
        label: filterLoc.label,
        description: filterLoc.description,
      });
      filteredData = getFilteredData(filteredOptions, filteredData);
    });
    setFilters(filteredOptions);
  }

  function handleTabFilterChange(value) {
    if (!tabFilter) return;

    onDataChange(
      filters.map((filter) =>
        filter.id !== tabFilter.id
          ? filter
          : {
            ...filter,
            options: filter.options.map((option) => ({
              ...option,
              actif: value !== "all" && option.value === value,
            })),
          },
      ),
    );
  }

  function handleApplyFilters(answers) {
    const updated = filters.map((f) => ({
      ...f,
      options: f.options.map((opt) => ({
        ...opt,
        actif: answers[f.name] === opt.value ? true : opt.actif,
      })),
    }));
    setFilters(updated);
    setShowAIModal(false);
  }

  function handlePostulate(completion) {
    setShowAIModal(false);
    if (!loading && completion) {
      setLoading(true);
      initCompletion(msalInstance, variables, contactId, completion)
        .then((res) => {
          if (res.ok) return res.json();
        })
        .then((newCandidature) => {
          if (newCandidature) {
            var completionsLoc = Object.assign([], allCompletions);
            var index = completionsLoc.findIndex((c) => c.id === completion.id);
            completionsLoc[index] = newCandidature;
            setAllCompletions(completionsLoc);
            setLoading(false);
            localStorage.setItem(
              "lastCandidature",
              JSON.stringify(newCandidature.objectAssociated),
            );
            navigate("/" + type?.name + "/" + completion.id);
          }
        })
        .catch(() => setLoading(false));
    }
  }

  const sidebarFilters = filters.filter(
    (f) => f.id !== "name" && f.id !== "description",
  );

  return (
    <div
      className={
        isVisible ? "my-forms-visible max-w-7xl mx-auto px-4 xl:px-0" : "hidden"
      }
    >
      {showAIModal && (
        <AIAssistantModal
          t={t}
          filters={filters}
          completions={completions}
          onClose={() => setShowAIModal(false)}
          onPostulate={handlePostulate}
          onApplyFilters={handleApplyFilters}
        />
      )}
      {showFiltersModal && (
        <FiltersModal
          t={t}
          filters={sidebarFilters}
          completions={completions}
          onClose={() => setShowFiltersModal(false)}
          onApply={(updatedFilters) => {
            const updatedFiltersById = new Map(
              updatedFilters.map((filter) => [filter.id, filter]),
            );
            onDataChange(
              filters.map((filter) =>
                updatedFiltersById.get(filter.id) ?? filter,
              ),
            );
            setShowFiltersModal(false);
          }}
        />
      )}

      {/* Page header */}
      <div className="pt-10 pb-6">
        <p className="text-xs font-bold color-primary-perso tracking-[0.2em] uppercase mb-3">
          {t("Intake")} {getAcademicYear()}
        </p>
        <h1
          className="font-bold text-gray-900 mb-3"
          style={{
            fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
          dangerouslySetInnerHTML={{ __html: t("Nos formations") }}
        />
        <p
          className="text-gray-500 max-w-lg"
          style={{ fontSize: "clamp(0.875rem, 1.5vw, 1rem)", lineHeight: 1.6 }}
        >
          {t(
            "Explorez nos programmes et candidatez en quelques minutes. Vos informations de compte sont automatiquement préremplies.",
          )}
        </p>
      </div>

      {/* AI Banner */}
      {completions.length > 1 &&
        <div
          className="flex items-center justify-between border px-5 py-4 mb-5 cursor-pointer"
          style={{
            borderRadius: "20px",
            borderColor: "color-mix(in srgb, var(--primary-color) 22%, #fff)",
            background:
              "linear-gradient(to right, color-mix(in srgb, var(--primary-color) 12%, #fff), #ffffff)",
            boxShadow: "rgba(16, 20, 34, 0.15) 0px 12px 30px -20px",
            transition: "box-shadow 0.25s ease, transform 0.25s ease",
          }}
          onClick={() => setShowAIModal(true)}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 18px 38px -26px color-mix(in srgb, var(--primary-color) 75%, #000)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow =
              "rgba(16, 20, 34, 0.15) 0px 12px 30px -20px";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <div className="flex items-center gap-4">
            <div className="hidden w-10 h-10 rounded-full bg-primary-perso md:flex items-center justify-center flex-shrink-0">
              <SparklesIcon className="h-5 w-5 text-white" />
            </div>
            <div>
              <p className="font-semibold text-sm leading-tight flex items-center gap-2">
                {t("Trouvez le programme fait pour vous")}
                <span className="text-xs bg-primary-perso text-white rounded px-1.5 py-0.5 font-bold">
                  IA
                </span>
              </p>
              <p className="text-xs text-gray-400 mt-1 mb-2">
                {t(
                  "Répondez à quelques questions, notre IA vous recommande la meilleure formation.",
                )}
              </p>
              <span className="md:hidden text-sm font-semibold color-primary-perso ">
                {t("Launch assistant")} →
              </span>
            </div>
          </div>
          <span className="hidden md:block text-sm font-semibold color-primary-perso whitespace-nowrap ml-4 flex-shrink-0">
            {t("Launch assistant")} →
          </span>
        </div>}

      {/* Active filter chips */}
      {filters.some((f) => f.options?.some((o) => o.actif)) && (
        <div className="flex flex-wrap gap-2 mb-3">
          {filters.flatMap((f) =>
            f.options
              .filter((o) => o.actif)
              .map((o) => (
                <button
                  onClick={() => {
                    const updated = filters.map((fi) =>
                      fi.id !== f.id
                        ? fi
                        : {
                          ...fi,
                          options: fi.options.map((op) =>
                            op.value !== o.value
                              ? op
                              : { ...op, actif: false },
                          ),
                        },
                    );
                    onDataChange(updated);
                  }}
                  className="ml-0.5 hover:opacity-60 transition-opacity"
                  aria-label={t("Remove filter")}
                >
                  <span
                    key={`${f.id}-${o.value}`}
                    className="inline-flex items-center gap-1.5 text-xs font-medium bg-white border border-primary-perso color-primary-perso rounded-full px-3 py-1"
                  >
                    <span className="text-gray-400">{f.label ?? f.id} :</span>{" "}
                    {o.label}
                    <XMarkIcon className="h-3 w-3" />
                  </span>
                </button>
              )),
          )}
          <button
            onClick={() =>
              onDataChange(
                filters.map((f) => ({
                  ...f,
                  options: f.options.map((o) => ({ ...o, actif: false })),
                })),
              )
            }
            className="text-xs text-gray-400 hover:text-gray-600 underline"
          >
            {t("Clear all")}
          </button>
        </div>
      )}

      {/* Search + Tab filters */}
      {!noAvailableForms && completions.length > 1 && (
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          <div className="relative flex-1">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder={t("Rechercher un programme...")}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 border rounded-[11px] text-sm focus:outline-none focus:ring-2 focus:ring-primary-perso focus:border-transparent"
              style={{ borderColor: "#e7eaef" }}
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            {tabFilter && (
              <>
                <button
                  onClick={() => handleTabFilterChange("all")}
                  className={`px-4 py-2 rounded-xl text-sm font-medium transition-colors ${!tabFilter.options.some((option) => option.actif) ? "bg-primary-perso text-white" : "bg-white border border-gray-200 text-gray-600 hover:border-gray-300"}`}
                >
                  {t("All")}
                </button>
                {tabFilter.options.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => handleTabFilterChange(opt.value)}
                    className={`px-4 py-2 rounded-xl text-sm font-medium transition-colors ${opt.actif ? "bg-primary-perso text-white" : "bg-white border border-gray-200 text-gray-600 hover:border-gray-300"}`}
                  >
                    {opt.label}
                  </button>
                ))}
              </>
            )}
            {sidebarFilters.length > 0 && (
              <button
                type="button"
                onClick={() => setShowFiltersModal(true)}
                className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:border-gray-300 hover:text-gray-900"
              >
                <AdjustmentsHorizontalIcon className="h-4 w-4" />
              </button>
            )}
          </div>
        </div>
      )}

      {/* Main content: sidebar + cards */}
      {filtersCompletion.length >= 1 ? (
        <div className="xl:grid xl:grid-cols-6 gap-6 h-full w-full z-1 relative">
          <div
            className={`${completions.length > 1 && sidebarFilters.length > 0 ? "xl:col-span-6" : "xl:col-span-6"} h-full overflow-y-auto  pt-4`}
          >
            <div className="grid md:grid-cols-2 gap-5 mb-5">
              {filtersCompletion.slice(0, 2).map((completion, k) => (
                <NewFormCard
                  key={k}
                  completion={completion}
                  type={type}
                  filters={cardFilters}
                  featured
                />
              ))}
            </div>
            {filtersCompletion.length > 2 && (
              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
                {filtersCompletion.slice(2).map((completion, k) => (
                  <NewFormCard
                    key={k}
                    completion={completion}
                    type={type}
                    filters={cardFilters}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="xl:col-span-5 flex justify-center items-center w-full mt-12">
          <div className="text-center">
            <svg
              className="mx-auto h-12 w-12 text-gray-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-700">
              {!noAvailableForms ?
                t("Aucun formulaire ne correspond à vos critères")
                : t("Aucun formulaire n'est disponible à candidater")}
            </h3>
          </div>
        </div>
      )}
    </div>
  );
}

export default withTranslation()(NewApplication);
